import {
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { styles } from '../monitoringCustomStyles';
import { ViewAsEnum, VIEW_AS_OPTIONS } from '../constants';

export function SelectViewAs(props) {
  const { viewAs: selectedViewAs, setViewAs } = props;

  return (
    <Stack width={'130px'} sx={{ marginRight: 2 }}>
      <FormControl fullWidth>
        <Select
          value={selectedViewAs}
          onChange={(e) => {
            setViewAs(e.target.value as ViewAsEnum);
          }}
          sx={{
            padding: '0px 0px 0px 0px !important',
            background: styles.color.greyBackground4,
            '.MuiSelect-select': {
              padding: '8px 32px 8px 8px !important',
            },
          }}
          renderValue={(selectedValue) => {
            const selectedOption = VIEW_AS_OPTIONS.find(
              (option) => option.value === selectedValue,
            );
            return (
              <Stack
                sx={{
                  flexDirection: 'row',
                  overflow: 'visible',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    display: 'flex',
                    marginRight: '4px',
                    color: styles.color.monotoneDarker,
                    whiteSpace: 'nowrap',
                  }}
                >
                  View As:
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    display: 'flex',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {selectedOption?.label || selectedValue}
                </Typography>
              </Stack>
            );
          }}
        >
          {VIEW_AS_OPTIONS.map((option) => {
            return (
              <MenuItem key={option.value} value={option.value}>
                <Typography>{option.label}</Typography>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Stack>
  );
}
